import React from 'react';
import { ArrowLeft, Bot, ShieldCheck, Users, Sparkles, Mail } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { logoUrl } from '../mockData';

const TrasparenzaIA = () => {
  const navigate = useNavigate();

  const points = [
    {
      icon: Bot,
      title: 'Nessuna IA in esercizio sul sito',
      text: "Questo sito web non utilizza sistemi di intelligenza artificiale per interagire con gli utenti, generare risposte automatiche, profilare i visitatori o assumere decisioni automatizzate.",
      color: '#2B7A9F',
    },
    {
      icon: Users,
      title: 'Gestione umana delle richieste',
      text: 'Tutte le richieste inviate tramite i moduli presenti sul sito (quotazioni, RCA, tirocini, contatti) sono lette, valutate e gestite esclusivamente da consulenti umani.',
      color: '#3AAFA9',
    },
    {
      icon: Sparkles,
      title: 'Contenuti con supporto IA',
      text: "Alcuni contenuti testuali e grafici del sito sono stati realizzati con il supporto di strumenti di intelligenza artificiale generativa, sempre sotto supervisione, revisione e approvazione redazionale umana.",
      color: '#E67E22',
    },
    {
      icon: ShieldCheck,
      title: 'Impegno per il futuro',
      text: "Qualora in futuro venissero introdotte funzionalità basate su IA (ad esempio assistenti virtuali), l'utente ne sarà informato in modo chiaro e preventivo, come previsto dall'Art. 50 del Regolamento UE 2024/1689.",
      color: '#5FB76E',
    },
  ];

  return (
    <div className="min-h-screen bg-gray-50">
      <header className="bg-white shadow-sm sticky top-0 z-50">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-4">
          <div className="flex items-center justify-between">
            <button
              data-testid="back-home-btn"
              onClick={() => navigate('/')}
              className="flex items-center space-x-2 text-[#2B7A9F] hover:text-[#3AAFA9] transition-colors duration-300"
            >
              <ArrowLeft size={20} />
              <span className="font-medium">Torna alla Home</span>
            </button>
            <img src={logoUrl} alt="Assietica" className="h-12 w-auto" />
          </div>
        </div>
      </header>

      <div className="bg-gradient-to-r from-[#2B7A9F] via-[#3AAFA9] to-[#5FB76E] text-white py-16">
        <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <div className="w-20 h-20 bg-white/20 backdrop-blur-md rounded-full flex items-center justify-center mx-auto mb-6">
            <Bot className="text-white" size={40} />
          </div>
          <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold mb-4">
            Trasparenza sull'Intelligenza Artificiale
          </h1>
          <p className="text-lg text-white/90 max-w-2xl mx-auto">
            Dichiarazione ai sensi del Regolamento UE 2024/1689 (AI Act)
          </p>
        </div>
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="bg-white rounded-2xl shadow-sm border border-gray-100 p-6 sm:p-8 mb-8">
          <p className="text-gray-700 leading-relaxed">
            <strong>Assietica Soc. Coop. Società Benefit</strong>, in ottemperanza al Regolamento UE
            2024/1689 (AI Act) e in coerenza con i propri valori di trasparenza verso gli Enti del
            Terzo Settore e le Cooperative che assiste, dichiara quanto segue:
          </p>
        </div>

        <div className="grid sm:grid-cols-2 gap-6">
          {points.map((p) => {
            const Icon = p.icon;
            return (
              <div
                key={p.title}
                className="bg-white rounded-xl p-6 border border-gray-100 shadow-sm hover:shadow-md transition-shadow duration-300"
              >
                <div
                  className="w-12 h-12 rounded-xl flex items-center justify-center mb-4"
                  style={{ backgroundColor: `${p.color}1A` }}
                >
                  <Icon size={24} style={{ color: p.color }} />
                </div>
                <h2 className="font-bold text-gray-800 mb-2">{p.title}</h2>
                <p className="text-gray-600 text-sm leading-relaxed">{p.text}</p>
              </div>
            );
          })}
        </div>

        <div className="mt-8 bg-[#2B7A9F]/5 rounded-xl p-6 border border-[#2B7A9F]/10 flex items-start gap-3">
          <Mail size={20} className="text-[#2B7A9F] flex-shrink-0 mt-0.5" />
          <p className="text-gray-700 text-sm leading-relaxed">
            Per qualsiasi chiarimento su questa dichiarazione è possibile scrivere a{' '}
            <a href="mailto:info@assietica.it" className="text-[#2B7A9F] underline font-medium">
              info@assietica.it
            </a>.
          </p>
        </div>

        <p className="text-gray-400 text-xs mt-8 text-center">
          Ultimo aggiornamento: giugno 2026
        </p>
      </div>
    </div>
  );
};

export default TrasparenzaIA;
